import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function LegalShell({ title, lastUpdated, children }) {
  return (
    <article className="prose prose-invert max-w-none font-body" data-testid="legal-content">
      <header className="mb-10 pb-6 border-b border-white/5">
        <p className="text-[#a83a4a] text-[10px] uppercase tracking-[0.3em] font-body mb-3">Legal</p>
        <h1 className="font-heading text-4xl md:text-5xl text-white mb-3 tracking-tight">{title}</h1>
        <p className="text-white/40 text-sm font-body">Last updated: {lastUpdated}</p>
      </header>

      <div className="space-y-6 text-white/70 leading-relaxed text-[15px]">
        {children}
      </div>

      <nav className="mt-12 pt-6 border-t border-white/5 flex flex-wrap gap-6 text-sm font-body">
        <Link to="/" className="text-white/40 hover:text-white transition">← Home</Link>
        <Link to="/privacy" className="text-white/40 hover:text-white transition">Privacy</Link>
        <Link to="/terms" className="text-white/40 hover:text-white transition">Terms</Link>
        <Link to="/support" className="text-white/40 hover:text-white transition">Support</Link>
      </nav>
    </article>
  );
}

export function LegalNav() {
  return (
    <nav className="bg-[#020202]/95 backdrop-blur-xl border-b border-white/[0.06] sticky top-0 z-50">
      <div className="container mx-auto max-w-4xl px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="legal-nav-home">
          <Logo size={28} />
          <span className="font-heading text-base text-white tracking-[0.28em]">RESET</span>
        </Link>
        <div className="flex gap-5 text-[11px] font-body uppercase tracking-[0.2em]">
          <Link to="/privacy" className="text-white/40 hover:text-white transition">Privacy</Link>
          <Link to="/terms" className="text-white/40 hover:text-white transition">Terms</Link>
          <Link to="/support" className="text-white/40 hover:text-white transition">Support</Link>
        </div>
      </div>
    </nav>
  );
}

export function H2({ children }) {
  return <h2 className="font-heading text-xl md:text-2xl text-white mt-10 mb-4 tracking-tight">{children}</h2>;
}

export function H3({ children }) {
  return <h3 className="font-heading text-base md:text-lg text-white/90 mt-6 mb-2 tracking-tight">{children}</h3>;
}
